import css from 'ui/widget/widget.module.scss'
import { omitFalse } from 'util/object'

export type OnDragEvent = {
  start?: true
  end?: true
  dx: number
  dy: number
}

export type OnDrag = {
  (event: OnDragEvent): void
}

type Drag = {
  x: number
  y: number
}

export function attachDrag(trigger: HTMLDivElement, frame: HTMLDivElement, onDrag: OnDrag) {
  let drag: Drag | undefined = undefined

  function fireDrag(event: MouseEvent) {
    if (!drag) return
    const start = event.type === 'mousedown'
    const end = event.type === 'mouseup'
    if (start) frame.classList.add(css.lock!)
    if (end) frame.classList.remove(css.lock!)
    const dx = event.clientX - drag.x
    const dy = event.clientY - drag.y
    onDrag(omitFalse({ start, end, dx, dy }))
  }

  function onMouseDown(event: MouseEvent) {
    event.preventDefault()
    drag = {
      x: event.clientX,
      y: event.clientY,
    }
    fireDrag(event)
  }

  function onMouseMove(event: MouseEvent) {
    fireDrag(event)
  }

  function onMouseUp(event: MouseEvent) {
    fireDrag(event)
    drag = undefined
  }

  trigger.addEventListener('mousedown', onMouseDown)
  window.addEventListener('mousemove', onMouseMove)
  window.addEventListener('mouseup', onMouseUp)

  return () => {
    trigger.removeEventListener('mousedown', onMouseDown)
    window.removeEventListener('mousemove', onMouseMove)
    window.removeEventListener('mouseup', onMouseUp)
  }
}
